import React, { useState } from 'react';
import { Button, Heading } from '../../components';
import { richText } from '../../util/richText';

import css from './ListingPage.module.css';
import BrandIconCard from '../../components/BrandIconCard/BrandIconCard';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const SectionTextMaybe = props => {
  const { text, accommodation, heading, showAsIngress = false } = props;
  const [showPopup, setShowpopup] = useState(false);
  const textClass = showAsIngress ? css.ingress : css.text;
  const content = richText(text, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
    breakChars: '/',
  });

  const handlePopup = () => {
    setShowpopup(prev => !prev);
  };

  React.useEffect(() => {
    if (showPopup) {
      document.body.classList.add('disableScroll');
    } else {
      document.body.classList.remove('disableScroll');
    }
  }, [showPopup]);


  return text ? (
    <section className={css.sectionTextWrapper}>
      {heading ? (
        <Heading as="h2" rootClassName={css.sectionHeading}>
          {heading}
        </Heading>
      ) : null}
      <h4>About your accommodation</h4>
      {/* <p className={textClass}>{content}</p> */}
      <div className={css.textNbtnWrapper}>
        <p className={textClass}>{accommodation}</p>
        {accommodation?.length >= 120 && (
          <div className={css.showAllBtn}>
            <Button onClick={handlePopup}>Read More</Button>
          </div>
        )}
      </div>
      {showPopup === true ? (
        <AccommodationPopup className={textClass} closeBtn={handlePopup} data={accommodation} />
      ) : null}
    </section>
  ) : null;
};

export default SectionTextMaybe;

const AccommodationPopup = ({ data, className, closeBtn }) => {
  return (
    <>
      <div className={css.accommodationPopupWrapper}>
        <div className={css.contentBox}>
          <button onClick={closeBtn} className={css.closeBtn}>
            <BrandIconCard type="close" />
          </button>
          <div className={css.contentContainer}>
            <h4>About your accommodation</h4>
            <p className={className}>{data}</p>
          </div>
        </div>
      </div>
    </>
  );
};
